import React, { BaseSyntheticEvent, useState } from 'react'
import {
  IonHeader,
  IonPage,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonLabel,
  IonToggle,
} from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { add, chevronBackOutline } from 'ionicons/icons'
import './AdditionalAssessments.page.css'
import AdditionalAssessmentsList from '../additionalAssessmentsList/AdditionalAssessmentsList.component'
import ActionButtons from '../../../components/actionButtons/ActionButtons.component'
import PopupComponent from '../../../components/infoPopup/Popup.component'
import { resetBodyAssessment, setSelectedExam } from '../bodyAssessment/store/bodyAssessment.actions'
import { BodyAssessmentConstants } from '../bodyAssessment/store/bodyAssessment.constants'
import { useDispatch, useSelector } from 'react-redux'
import {
  resetBodySurveyValues,
  setBodValue,
  setBodySurvey,
  setEnabledZoom,
  setSequence,
} from '../bodyAssessment/bodySurvey/store/bodySurvey.actions'
import { BodySurveyConstants } from '../bodyAssessment/bodySurvey/store/bodySurvey.constants'
import { saveBodySurvey } from '../bodyAssessment/bodySurvey/store/bodySurvey.actions'
import './AdditionalAssessments.page.css'
import { getAdditionalAssessmentsSelector } from '../selectors/getAdditionalAssessments.selector'
import { setAssessmentsList } from '../store/additionalAssessments.actions'

const AdditionalAssessments: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const [showCopyAlert, setShowCopyAlert] = useState(false)
  const [optCopy, setOptCopy] = useState(false)
  const assessmentData = useSelector(getAdditionalAssessmentsSelector)
  const { bodySurveys } = assessmentData

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  const onAddClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(resetBodySurveyValues())
    dispatch(resetBodyAssessment())
    dispatch(setBodValue(false))
    if (bodySurveys.length) {
      setShowCopyAlert(true)
    } else {
      handleBodySurveyRedirection()
    }
  }

  const handleBodySurveyRedirection = () => {
    dispatch(setSequence(BodySurveyConstants.OPERATION_TYPE_INCREMENT))
    dispatch(saveBodySurvey())
    history.push(TabConstants.BODY_ASSESSMENT)
    dispatch(setSelectedExam(BodyAssessmentConstants.BODY_SURVEY))
  }

  const onCopyToggleClick = () => {
    setOptCopy((prev) => !prev)
  }

  const handleHideCopyConfirmation = () => {
    setShowCopyAlert(false)
    setOptCopy(false)
  }

  const handleCopyAssessment = () => {
    const assessmentListArr = JSON.parse(JSON.stringify(bodySurveys))
    const lastAssessmentObj = { ...assessmentListArr[assessmentListArr.length - 1] }
    lastAssessmentObj.seq = lastAssessmentObj.seq + 1
    lastAssessmentObj.__documentFindings = false
    assessmentListArr.push(lastAssessmentObj)
    dispatch(setAssessmentsList(assessmentListArr))
    dispatch(setBodySurvey(lastAssessmentObj))
    dispatch(saveBodySurvey())
  }

  const actionButtonObj = [
    {
      label: t('common.buttons.Cancel'),
      className: 'btn btn-secondary  mr-8',
      onClick: () => {
        handleHideCopyConfirmation()
      },
    },
    {
      label: t('common.buttons.Continue'),
      className: 'btn btn-primary',
      onClick: () => {
        history.push(TabConstants.BODY_ASSESSMENT)
        setShowCopyAlert(false)
        dispatch(setSelectedExam(BodyAssessmentConstants.BODY_SURVEY))
        dispatch(setEnabledZoom(false))
        if (optCopy) {
          handleCopyAssessment()
        } else {
          dispatch(setSequence(BodySurveyConstants.OPERATION_TYPE_INCREMENT))
          dispatch(saveBodySurvey())
        }
      },
    },
  ]

  const copyConfirmationPopupbuttons = <ActionButtons actionButtonObj={actionButtonObj} />

  return (
    <>
      <IonPage id='AdditionalAssessmentPage'>
        <PCRHeader />
        <IonHeader className='ion-no-padding'>
          <IonToolbar color='light'>
            <IonButtons slot='start'>
              <IonButton color='primary-alt' data-testid='BackButton' onClick={onBackClick}>
                <IonIcon icon={chevronBackOutline} />
                {t('common.buttons.Back')}
              </IonButton>
            </IonButtons>
            <IonButtons slot='end'>
              <IonButton
                data-testid='CreateAssessmentTablet'
                className='primary'
                onClick={onAddClick}
                color='primary-alt'>
                <div className='add-assessment-label'>{t('additionalAssessments.CreateAssessment')}</div>
                <div className='add-assessment-icon'>
                  <IonIcon icon={add} />
                </div>
              </IonButton>
            </IonButtons>
            <IonTitle>{t('additionalAssessments.Assessments')}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <AdditionalAssessmentsList />
      </IonPage>
      <PopupComponent
        id='popup-container'
        dataTestId='copy-assessment-popup'
        isOpen={showCopyAlert}
        handleHidePopover={handleHideCopyConfirmation}
        className='info-popup copy-assessment-popup'>
        <>
          <div className='info-heading'>
            {t('additionalAssessments.CopyFrom')} Assessment{' '}
            {bodySurveys.length && bodySurveys[bodySurveys.length - 1].seq} ?
          </div>
          <div className='copy-assessment-content'>
            <div className='mb-20'>
              <span>{t('additionalAssessments.CopyAssessmentYes')}</span>{' '}
              {t('additionalAssessments.CopyAssessmentDescription')}{' '}
              {bodySurveys.length && bodySurveys[bodySurveys.length - 1].seq}
            </div>
            <div className='ion-flex ion-align-items-center'>
              <IonLabel color={!optCopy ? 'primary-alt' : ''}>{t('additionalAssessments.No')}</IonLabel>
              <IonToggle checked={optCopy} onClick={onCopyToggleClick} />
              <IonLabel color={optCopy ? 'primary-alt' : ''}>{t('additionalAssessments.Yes')}</IonLabel>
            </div>
          </div>
          <div className='mt-20'>{copyConfirmationPopupbuttons}</div>
        </>
      </PopupComponent>
    </>
  )
}
export default AdditionalAssessments
